<template>
  <div class="has-background-info-light">
    <div class="modal-header">
      <h2 class="window-header subtitle mb-4">{{ title }}</h2>
    </div>
    <div class="box">
      <!-- Uredi detalje -->
      <div>
        <!-- Vozač -->
        <div class="columns">
          <div class="column has-text-centered"><label>Vozač:</label></div>
          <div class="column is-four-fifths">
            <vue-select
              class="has-background-info-light"
              type="text"
              label="name"
              :clearable="false"
              :options="drivers"
              v-model="selectedDriver"
            />
          </div>
        </div>

        <!-- Vozač -->
        <div class="columns">
          <div class="column has-text-centered"><label>Suvozač:</label></div>
          <div class="column is-four-fifths">
            <vue-select
              class="has-background-info-light"
              type="text"
              label="name"
              :clearable="true"
              :options="drivers"
              v-model="selectedCodriver"
            />
          </div>
        </div>

        <!-- Vozač -->
        <div class="columns">
          <div class="column has-text-centered"><label>Tura:</label></div>
          <div class="column is-four-fifths">
            <vue-select
              class="has-background-info-light"
              type="text"
              label="name"
              :clearable="false"
              :options="routeCards"
              v-model="selectedRouteCard"
            />
          </div>
        </div>
      </div>

      <!-- Prikaz rute na mapi -->
      <gps-map :routeGeneral="routeGeneral" :routeActual="routeActual">
      </gps-map>

      <!-- Buttons -->
      <div class="columns">
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="saveClicked"
          >
            SAČUVAJ
          </button>
        </div>
        <div class="column">
          <button
            class="button is-info is-light is-rounded"
            @click="cancelClicked"
          >
            ODUSTANI
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GpsMap from "./GpsMap.vue";
export default {
  components: { GpsMap },
  name: "RouteEdit",

  props: {
    title: String,
    route: Object,
    routeGeneral: Array,
    routeActual: Array,
  },

  data() {
    return {
      drivers: [],
      routeCards: [],
      selectedDriver: null,
      selectedCodriver: null,
      selectedRouteCard: null,
    };
  },

  mounted() {
    this.prepare();
  },

  methods: {
    prepare() {
      console.log("ovdje");
      console.log(this.route);
      console.log(this.route.routeGeneral);
      console.log(this.route.routeActual);
      this.drivers = this.$store.state.general.drivers;
      this.routeCards = this.$store.state.general.routeCards;

      const driverId = this.route.driverId;
      console.log(driverId);
      this.selectedDriver = this.drivers.find((d) => d.id === driverId);
      console.log(this.selectedDriver);

      const codriverId = this.route.codriverId;
      this.selectedCodriver = this.drivers.find((d) => d.id === codriverId);

      const routeCardId = this.route.routeCardId;
      this.selectedRouteCard = this.routeCards.find(
        (r) => r.id === routeCardId
      );
    },

    saveClicked() {
      console.log("SAVE CLICKED~");
      this.$emit("saveClicked", {
        driverId: this.selectedDriver.id,
        codriverId: this.selectedCodriver ? this.selectedCodriver.id : null,
        tourByCard: this.selectedRouteCard.id,
        routeLogId: this.route.routeLogId,
      });
    },

    cancelClicked() {
      console.log("CANCEL CLICKED!");
      this.$emit("cancelClicked", {
        driverId: this.selectedDriver,
        codriverId: this.selectedCodriver,
        tourByCard: this.selectedRouteCard,
        routeLogId: this.route.routeLogId,
      });
    },
  },
};
</script>

